export const publicRoutes = [
	'/reset-password',
	'/sign-up',
	'/login',
	'/change-password',
	'/click-fraud-calculator',
	'/click-fraud-report',
	// Tokenised Analytics report render route (DEV-2377). External recipients open
	// the emailed link with no ClickGuard session, so it must skip App's auth gate
	// (App.tsx redirects any non-public route to Auth0 before the Routes mount).
	// The trailing slash keeps this from matching an unrelated future '/report…'.
	'/report/',
	// Dev-only: auth-free /preview shell for previewing DS components without a backend.
	// Guarded so the bypass never exists in a production build.
	...(process.env.NODE_ENV !== 'production' ? ['/preview'] : [])
]

export const responsiveRoutes = [
	'/emails/verify',
	'/login',
	'/sign-up',
	'/reset-password',
	'/change-password',
	// Documentation is readable on phones; the existing Auth0 gate still applies.
	'/docs',
	'/changelog',
	'/reader',
	// The emailed report link is a loader that downloads a PDF — fine on a phone,
	// so it skips the "works best on desktop" wall.
	'/report/'
]
